import React from "react";
import styled from "@emotion/styled";
import { App } from "antd5";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import { useMakeWebhook } from "lib/hooks/api/make/useMakeWebook";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { MakeWebhookName } from "lib/types/graphQLEnums";

type Props = {
  open: boolean;
  stageName: string;
  onOpenChange: (open: boolean) => void;
  setJoinedBidWaitlist: () => void;
  updateStage: () => void;
};

export default function ToBidModal({
  open,
  onOpenChange,
  stageName,
  setJoinedBidWaitlist,
  updateStage,
}: Props) {
  const { message } = App.useApp();
  const { mutate: joinBidWaitlist } = useMakeWebhook({
    onSuccess: () => {
      updateStage();
      setJoinedBidWaitlist();
      message.success("You have been added to the bidding workflow waitlist!");
      onOpenChange(false);
    },
    onError: () => {
      message.error("There was an error adding you to the waitlist. Please try again.");
    },
  });

  const handleOpenChange = (open: boolean) => {
    if (!open) updateStage();
    onOpenChange(open);
  };

  return (
    <Modal open={open} onOpenChange={handleOpenChange} maxWidth="378px">
      <Content>
        <Flex gap={8} alignItems="center">
          <UIcon icon="checkCircle" size={20} />
          <Text h3>Marked as {stageName}</Text>
        </Flex>
        <DescriptionContainer>
          <Text>
            That's great! We're currently working on a feature to help manage bidding workflow. Let
            us know below if you're like to be the first to know about it.
          </Text>
        </DescriptionContainer>
        <ButtonContainer>
          <Button buttonType="secondary" onClick={() => handleOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              joinBidWaitlist({
                req: {
                  hookName: MakeWebhookName.BidWaitlist,
                },
              });
            }}
          >
            Join waitlist
          </Button>
        </ButtonContainer>
      </Content>
    </Modal>
  );
}

const Content = styled.div({
  padding: 16,
});

const DescriptionContainer = styled.div({
  marginTop: 8,
});

const ButtonContainer = styled(Flex)({
  marginTop: 24,
  justifyContent: "flex-end",
  gap: 8,
});
